interface IConfig {
  activeIndexes: number[]
  noSelected: boolean
  activeClass: string
  pickerSelector: string
  multiplePickerSelector: string
  buttonSelector: string
  itemSelector: string
  on?: { change: (picker: Element, index: number) => void }
}

const DEFAULT_CONFIG: IConfig = {
  activeIndexes: [], // starting item with the active state (array can be empty)
  noSelected: false, // controls if there can be no picker selected
  activeClass: 'active', // class name for active item
  pickerSelector: '[data-picker]', // selector for picker container
  multiplePickerSelector: '[data-picker-multiple]', // selector for multiple picker container
  buttonSelector: '[data-picker-btn]', // selector for button, switch state on item
  itemSelector: '[data-picker-item]', // selector for item in picker
}

const initializePickers = (config?: IConfig) => {
  const currConfig = config ?? DEFAULT_CONFIG

  const pickers = currConfig.pickerSelector
    ? document.querySelectorAll(currConfig.pickerSelector)
    : ([] as unknown as NodeListOf<Element>)
  const multiplePickers = currConfig.multiplePickerSelector
    ? document.querySelectorAll(currConfig.multiplePickerSelector)
    : ([] as unknown as NodeListOf<Element>)

  if (pickers.length === 0 && multiplePickers.length === 0) {
    return console.log(
      `no DOM elements with "${currConfig.pickerSelector}" or "${currConfig.multiplePickerSelector}" found`,
    )
  }

  handleSingle(pickers, currConfig)
  handleMultiple(multiplePickers, currConfig)
}

const handleSingle = (pickers: NodeListOf<Element>, config: IConfig) => {
  if (pickers.length === 0) return

  pickers.forEach((picker) => {
    const buttons = picker.querySelectorAll(config.buttonSelector)
    const items = picker.querySelectorAll(config.itemSelector)
    console.log(items)

    if (!hasButtons(buttons, config) || !hasItems(items, config)) return

    buttons.forEach((button, index) => {
      if (
        !button.classList.contains(config.activeClass) &&
        config.activeIndexes.includes(index)
      ) {
        button.classList.add(config.activeClass)
        items?.[index].classList.add(config.activeClass)
      }

      const handleClick = () => {
        // If "space rental" picker on select
        if (config.buttonSelector === '[data-plan-picker-btn]') {
          const dataPlanOptionSeleted = picker.querySelector(
            `[data-plan-option-seleted]`,
          )

          if (dataPlanOptionSeleted) {
            dataPlanOptionSeleted.innerHTML = button.getAttribute(
              'data-value',
            ) as string

            const allHighlighted = picker.querySelectorAll('.is-highlighted')
            const dataPickerOption = picker.querySelectorAll(
              '[data-picker-option]',
            )

            if (allHighlighted.length > 0) {
              allHighlighted.forEach((item) => {
                item.classList.remove('is-highlighted')
              })
            }

            dataPickerOption?.[index].classList.add('is-highlighted')
          }
        }

        if (config.buttonSelector === '[data-picker-option]') {
          const dataPlanOptionSeleted = picker.querySelector(
            `[data-plan-option-seleted]`,
          )

          if (dataPlanOptionSeleted) {
            dataPlanOptionSeleted.innerHTML = button.getAttribute(
              'data-value',
            ) as string

            const allHighlighted = picker.querySelectorAll('.is-highlighted')

            if (allHighlighted.length > 0) {
              allHighlighted.forEach((item) => {
                item.classList.remove('is-highlighted')
              })
            }

            button.classList.add('is-highlighted')
          }
          // window.selectSpace.setChoiceByValue(button.getAttribute('data-value') as string);
          window.selectSpace.hideDropdown()
        }

        if (!config.noSelected && button.classList.contains('active')) return

        if (config?.on?.change) config.on.change(picker, index)

        buttons?.[config.activeIndexes[0]]?.classList.remove(config.activeClass)
        items?.[config.activeIndexes[0]]?.classList.remove(config.activeClass)

        const isEmptable =
          config.noSelected && config.activeIndexes.includes(index)

        config.activeIndexes = isEmptable ? [] : [index]

        if (isEmptable) return

        button.classList.add(config.activeClass)
        items?.[index].classList.add(config.activeClass)
      }

      button.addEventListener('click', handleClick)
    })
  })
}

const handleMultiple = (
  multiplePickers: NodeListOf<Element>,
  config: IConfig,
) => {
  if (multiplePickers.length === 0) return

  multiplePickers.forEach((picker) => {
    const buttons = picker.querySelectorAll(config.buttonSelector)
    const items = picker.querySelectorAll(config.itemSelector)

    if (!hasButtons(buttons, config) || !hasItems(items, config)) return

    buttons.forEach((button, index) => {
      if (
        !button.classList.contains(config.activeClass) &&
        config.activeIndexes.includes(index)
      ) {
        button.classList.add(config.activeClass)
        items?.[index].classList.add(config.activeClass)
      }

      const handleClick = () => {
        if (
          !config.noSelected &&
          config.activeIndexes.length === 1 &&
          button.classList.contains('active')
        )
          return

        const activeIndex =
          config.activeIndexes[config.activeIndexes.indexOf(index)]

        if (button.classList.contains('active')) {
          buttons?.[activeIndex]?.classList.remove(config.activeClass)
          items?.[activeIndex]?.classList.remove(config.activeClass)

          config.activeIndexes = config.activeIndexes.filter((i) => i !== index)
        } else {
          button.classList.add(config.activeClass)
          items?.[index].classList.add(config.activeClass)

          config.activeIndexes = [...config.activeIndexes, index]
        }
      }

      button.addEventListener('click', handleClick)
    })
  })
}

const hasButtons = (buttons: NodeListOf<Element>, currConfig: IConfig) => {
  if (buttons.length === 0) {
    console.log(`no DOM elements with "${currConfig.buttonSelector}" found`)

    return false
  }

  return true
}

const hasItems = (items: NodeListOf<Element>, currConfig: IConfig) => {
  if (items.length === 0) {
    console.log(`no DOM elements with "${currConfig.itemSelector}" found`)

    return false
  }

  return true
}

export default initializePickers
